import { i18n } from "../../../boot/i18n";
// The default export is the Quasar store-factory on this branch; the live
// instance is the named export (main's Vue2 default-export doesn't exist here).
import { store } from "../../../store";

// Only admins and accounting manage mileage rates. All employees can still
// read the rates (they drive reimbursement math) via the store, but the
// management page itself is restricted.
const manageAuth = () =>
  Boolean(
    store.state.main.user &&
      (store.state.main.user.isAdmin ||
        store.state.main.user.hasRole("accounting"))
  );

export default {
  routes: [
    {
      name: "mileage-rates",
      path: "mileage-rates",
      meta: {
        icon: "mileage",
        title: i18n.global.tc("Mileage Rate", 2),
        color: "primary",
        auth: manageAuth,
      },
      component: () => import("pages/employee/MileageRates"),
    },
  ],

  dialogs: [
    {
      name: "mileage-rate-new",
      path: "/accounting/mileage-rates/new",
      props: true,
      meta: {
        icon: "mileage",
        title: i18n.global.t("New Mileage Rate"),
        color: "primary",
        auth: manageAuth,
      },
      component: () => import("../../../dialogs/employee/MileageRateEdit"),
    },
    {
      name: "mileage-rate-edit",
      path: "/accounting/mileage-rates/:rateID/edit",
      props: true,
      meta: {
        icon: "mileage",
        title: i18n.global.t("Edit Mileage Rate"),
        color: "primary",
        auth: manageAuth,
      },
      component: () => import("../../../dialogs/employee/MileageRateEdit"),
    },
  ],
};
